let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hdkrH")).then(() => parcelRequire('529Ow'));